import React from 'react'

export const TrueMarkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
        <path d="M3.99996 9.04397L0.355713 5.39972L1.39996 4.35547L3.99996 6.95547L10.6 0.355469L11.6442 1.39972L3.99996 9.04397Z" fill="#12B6EA"/>
    </svg>
  )
}
